import { AxiosResponse } from 'axios';
import { apiClient } from '../config/httpClient';
import { LoginResponse } from '../types';

export class AuthService {
    googleLogin(token: string): Promise<AxiosResponse<LoginResponse>> {
        return apiClient.post<LoginResponse>('/auth/google-login', { token });
    }
    
    googleLoginAuthCode(code: string): Promise<AxiosResponse<LoginResponse>> {
        return apiClient.post<LoginResponse>('/auth/google-login', { code });
    }
}

export const authService = new AuthService();
